import { Divider, Flex, Stack } from '@mantine/core';
import { NotFound } from 'src/components/NotFound';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { SyncthingFolderDetails } from 'src/components/SyncthingFolderDetails';
import { ActionFooter } from 'src/components/ActionFooter';
import {
  DeviceDetails,
  DeviceLocation,
} from 'src/features/device/feature-device-details';

import { useDeviceDetails } from './use-device-details';

export const Device = () => {
  const { device, isPending, handleDelete, handleRestart, handleCancel } =
    useDeviceDetails();

  if (isPending) {
    return <PageLoader visible={isPending} />;
  }

  if (!device) {
    return (
      <NotFound description="The device you're looking for doesn't exist" />
    );
  }

  return (
    <Flex direction="column" justify="space-between" style={{ height: '100%' }}>
      <Stack gap="sm">
        <PageTitle title={device.playwall_id} />

        <DeviceDetails device={device} onRestartClick={handleRestart} />

        <Divider my="md" />

        <SyncthingFolderDetails
          syncthingFolder={device.syncthing_folder}
          title="Syncthing Folder Details"
        />

        <Divider my="md" />

        <DeviceLocation device={device} />
      </Stack>

      <ActionFooter
        onDelete={handleDelete}
        onCancel={handleCancel}
        showSubmitButton={false}
      />
    </Flex>
  );
};
